import "./EditARCIssueSubscriptions.html";
import "./EditARCIssueSubscriptions.scss";

import "../FindAddUser/FindAddUserComponent";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EditARCIssueSubscriptionsComponentController from "./EditARCIssueSubscriptionsComponentController";

export default class EditARCIssueSubscriptionsComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            notificationConfiguration: "=",
            site: "<",
            subscriptions: "=",
            disabled: "<",
        };
        this.controller = EditARCIssueSubscriptionsComponentController;
        this.templateUrl = "/App/Components/Forms/EditARCIssueSubscriptions/EditARCIssueSubscriptions.html";
    }
}

module("mmManagePortal").component("irEditArcIssueSubscriptions", new EditARCIssueSubscriptionsComponent());
